export default __webpack_public_path__ + "static/media/ford.fcd02945.jpg";